module.exports = __webpack_public_path__ + "static/media/portrait8.187213c0.jpg";